import { Box, Typography } from "../../../../../../components";

export function AnimationFindProdutoAI({ currentStep, steps, loading }) {
  const lastIndex =
    Array.isArray(steps) && steps.length > 0
      ? Math.max(0, steps.length - 1)
      : 0;
  const safeIndex =
    Array.isArray(steps) && steps.length > 0
      ? Math.min(Math.max(0, currentStep), lastIndex)
      : 0;
  const progressPercent = (() => {
    if (!Array.isArray(steps) || steps.length <= 1) return 100;
    const denom = lastIndex === 0 ? 1 : lastIndex;
    const p = Math.round((Math.min(currentStep, lastIndex) / denom) * 100);
    return Math.max(0, Math.min(100, p));
  })();
  const currentLabel =
    Array.isArray(steps) && steps.length > 0 ? steps[safeIndex] : "";
  const isAnimating = currentStep < lastIndex;
  const singleStepLabel = currentLabel;
  const getIconFor = (idx) => {
    const set = [
      "ph-fill ph-cpu",
      "ph-fill ph-sparkle",
      "ph-fill ph-atom",
      "ph-fill ph-list",
      "ph-fill ph-calculator",
      "ph-fill ph-arrows-clockwise",
      "ph-fill ph-shield-check",
      "ph-fill ph-check-circle",
    ];
    return set[idx] || set[idx % set.length] || "ph-thin ph-circle";
  };

  return (
    <>
      <Box sx={{ textAlign: "center", mb: 2 }}>
        <div className="ai-main-circle">
          <div className={`ai-main-ring ${isAnimating ? "spin" : ""}`} />
          <i
            className={`${getIconFor(safeIndex)} ai-main-icon`}
            style={{ fontSize: 32, position: "relative", zIndex: 2 }}
          />
        </div>
        <Typography
          variant="body2"
          color="textSecondary"
          className="ai-main-label"
        >
          {currentLabel}
        </Typography>
        <Typography
          variant="caption"
          color="textSecondary"
          sx={{ display: "block", mt: 1 }}
        >
          {loading ? "Buscando sugestão..." : ""}
        </Typography>
      </Box>

      <Box sx={{ mb: 2 }}>
        <div className="ai-progress-track">
          <div
            className="ai-progress-bar"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
          }}
        >
          <Typography variant="body2" color="textSecondary">
            {currentLabel}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {progressPercent}%
          </Typography>
        </Box>
      </Box>

      <Box>
        {singleStepLabel
          ? (() => {
              const label = singleStepLabel;
              const idx = safeIndex;
              const isDone =
                currentStep > lastIndex ||
                (currentStep === lastIndex && !loading);
              const isCurrent = true;
              return (
                <div key={label || idx} className="ai-step-row">
                  <div
                    className={`ai-step-icon ${
                      isDone ? "ai-step-complete" : "ai-step-pending"
                    }`}
                    style={{ marginRight: 12 }}
                  >
                    {isDone ? (
                      <i
                        className="ph-fill ph-check-circle"
                        style={{ fontSize: 16, color: "#fff" }}
                      />
                    ) : isAnimating || loading ? (
                      <div className="ai-spinner" />
                    ) : (
                      <i
                        className={`${getIconFor(idx)} `}
                        style={{ fontSize: 14 }}
                      />
                    )}
                  </div>
                  <div style={{ flex: 1 }}>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: isCurrent ? 600 : 500 }}
                    >
                      {label}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {isDone && "Concluído"}
                      {!isDone && "Em andamento"}
                    </Typography>
                  </div>
                </div>
              );
            })()
          : null}
      </Box>
    </>
  );
}
